<template>
  <div id="data-list-list-view" class="data-list-container">

  <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="roles">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ roles.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : roles.length }} of {{ roles.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="id">ID</vs-th>
        <vs-th>标题</vs-th>
        <vs-th>内容</vs-th>
        <vs-th>时间</vs-th>
        <vs-th>状态</vs-th>
        <vs-th>操作</vs-th>

      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click.native="readMessage(tr)">

              <vs-td>
                <p class="product-name font-medium">{{ tr.id }}</p>
              </vs-td>

              <vs-td>
                <p>{{ tr.title }}</p>
              </vs-td>

              <vs-td>
                <p>{{ tr.content }}</p>
              </vs-td>

              <vs-td>
                <p>{{ tr.time }}</p>
              </vs-td>

              <vs-td>
                <vs-chip :color="getStatusColor(tr)">{{ tr.statusText }}</vs-chip>
              </vs-td>

              <vs-td>
                <vs-button class="ml-4" color="danger" size="small" type="filled" @click="delMessage(tr.id)">删除</vs-button>
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>

import { getToken } from '@/utils/tools';
import { list, read, del } from '@/api/message'

export default {
  components: {
  },
  data() {
    return {
      selected: [],
      roles: [],
      currentMenu: {},
      itemsPerPage: 5,
      isMounted: false,
      addNewDataSidebar: false,
      addModel: true,
    }
  },
  created() {
    this.getList(-1)
  },
  computed: {
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    
  },
  methods: {
    getStatusColor(tr) {
      let color
      if (tr.status == 1) {
        tr.statusText = '已读'
        color = ''
      } else {
        tr.statusText = '未读'
        color = 'warning'
      }
      return color
    },
    formatData(data) {
      return data
    },
    getList() {
      list({
        access_token: getToken(),
      }).then(res => {
        const data = res.data
        if (data.list.length !== 0) this.roles = data.list
      })
    },
    readMessage(tr) {
      if (tr.status == 1) return false
      let that = this
      read({
        access_token: getToken(),
        messageId: tr.id
      }).then(() => {
        that.getList()
      })
    },
    delMessage(id) {
      let that = this
      that.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认提示',
        text: '删除后的数据无法恢复，请确定你是否要删除？',
        accept: () => {
          del({
            access_token: getToken(),
            messageId: id
          }).then(res => {
            const data = res.data
            this.$vs.notify({
              title:'成功',
              text: data.err_msg,
              color:'success',
              iconPack: 'feather',
              icon:'icon-alert-circle'
            })
            that.getList()
          })
        },
        acceptText: '确定',
        cancelText: '取消'
      })
    }
  },
  
  mounted() {
    this.isMounted = true;
  },
}
</script>

<style lang="scss">
#data-list-list-view {
  white-space: nowrap;
  .vs-con-table {

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
